<template>
  <div class="edit_index">
    <edit v-if="start" />
  </div>
</template>
<script>
  import edit from './edit';

  export default {
    components: {
      edit,
    },
    data() {
      return {
        start: true,
      };
    },
    watch: {
      '$route.name': function() {
        this.start = false;
        this.$nextTick(() => {
          this.start = true;
        });
      },
    },
  };
</script>
